function setCookie(name, value, expiryDays, domain, path) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + (expiryDays || 365));

  var cookie = [
    name + "=" + value,
    "expires=" + exdate.toUTCString(),
    "path=" + (path || "/"),
  ];

  document.cookie = cookie.join(";");
}

function setAlertBoxClosed() {
  var b = new Date().getTime();
  setCookie("DONEGDPRAlertBoxClosed", b, 365);
}

(function($) {
  $(function() {
    $.cookieSettings = Cookies.get("DONEGDPRConsent");

    if ($.cookieSettings != undefined) {
      $.cookieSettings = JSON.parse($.cookieSettings);
    } else {
      setCookie(
        "DONEGDPRConsent",
        JSON.stringify({
          functional: true,
          performance: true,
          targeting: true,
        }),
        365
      );
      $(".done-gdpr-alert-box-wrapper").addClass("active");
    }

    if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
      window["ga-disable-GTM-MKKDDBZ"] = false;

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }

      gtag("js", new Date());
      gtag("config", "GTM-MKKDDBZ");
    } else {
      window["ga-disable-GTM-MKKDDBZ"] = true;

      var cookies = Cookies.get();

      if ("" !== cookies) {
        $.each(cookies, function(index) {
          index = "" + index;

          if ("_ga" === index || "_gid" === index || "_gat" === index) {
            Cookies.remove(index, { domain: document.domain });
          }
        });
      }
    }

    $(document).on("click", ".js-open-cookie", function(e) {
      e.preventDefault();
      cookiedone.showCookieSettings();

      if (
        $.cookieSettings != undefined &&
        $.cookieSettings.performance == true
      ) {
        $(".done-gdpr-status-checkbox.performance").attr("checked", true);
      }
      if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
        $(".done-gdpr-status-checkbox.targeting").attr("checked", true);
      }
    });

    $(document).on("click", "#done-gdpr-save-button", function(e) {
      location.reload();
    });

    $(document).on("click", ".done-gdpr-button-allow", function(e) {
      e.preventDefault();
      e.stopPropagation();
      cookiedone.allowAll();
      location.reload();
    });
  });
})(jQuery);
